import Task24 from '@carbon/icons-react/lib/task/24.js';
import WarningOther24 from '@carbon/icons-react/lib/warning--other/24.js';
export const statuses = Object.freeze({
  INPROGRESS: {
    id: 'INPROGRESS',
    icon: WarningOther24,
    description: 'In Progress...',
    defaultColor: 'SIAred'
  },
  COMPLETE: {
    id: 'COMPLETE',
    icon: Task24,
    description: 'Complete',
    defaultColor: 'SIAblack'
  }
});